import { Divider, Stack, Typography } from '@mui/material';
import { ContainedModal } from 'components/molecules';
import { useTreatmentConsultation } from 'context';
import React, { useMemo } from 'react';

export const ViewTreatmentPrescriptionModal: React.FC = () => {
  const { handleChangeSelectedPrescription, selectedPrescription } =
    useTreatmentConsultation();

  const handleClose = () => {
    handleChangeSelectedPrescription(undefined);
  };

  const medicaments = useMemo(() => {
    return (
      selectedPrescription?.filter(({ type }) => type === 'medicament') ?? []
    );
  }, [selectedPrescription]);

  const exams = useMemo(() => {
    return selectedPrescription?.filter(({ type }) => type === 'exam') ?? [];
  }, [selectedPrescription]);

  return (
    <ContainedModal
      isOpen={Boolean(selectedPrescription)}
      onClose={handleClose}
      title="DETALHES DA PRESCRIÇÃO"
    >
      <Stack px={3} mt={4} spacing={4}>
        {medicaments?.length ? (
          <Stack spacing={2}>
            <Typography color="#000" fontWeight={400} fontSize={18}>
              Medicamentos
            </Typography>

            <Divider />

            {medicaments?.map(({ name, posology, quantity, way }, index) => {
              const title = way ? `${name}, Uso ${way}` : name;

              return (
                <Stack key={index}>
                  <Typography color="#000" fontWeight={500} fontSize={16}>
                    {title}
                  </Typography>

                  <Typography
                    color="#000"
                    fontWeight={400}
                    fontSize={16}
                    ml={3}
                  >
                    {posology}
                  </Typography>

                  {quantity ? (
                    <Typography
                      color="#000"
                      fontWeight={400}
                      fontSize={16}
                      ml={3}
                      mt={0.5}
                    >
                      Quantidate: {quantity}
                    </Typography>
                  ) : null}
                </Stack>
              );
            })}
          </Stack>
        ) : null}

        {exams?.length ? (
          <Stack spacing={2}>
            <Typography color="#000" fontWeight={400} fontSize={18}>
              Exames
            </Typography>

            <Divider />

            {exams?.map(({ name, indication }, index) => {
              return (
                <Stack key={index}>
                  <Typography color="#000" fontWeight={500} fontSize={16}>
                    {name}
                  </Typography>

                  <Typography
                    color="#000"
                    fontWeight={400}
                    fontSize={16}
                    ml={3}
                  >
                    {indication}
                  </Typography>
                </Stack>
              );
            })}
          </Stack>
        ) : null}
      </Stack>
    </ContainedModal>
  );
};
